<div class="market_comparision" *ngIf="indexName && hasValidIndexData()">
   <h2 class="company_medium_title mb-0 fw-600">
      {{ name }} ({{ ticker }}) vs {{ indexName }} Comparative Returns
   </h2>

   <p class="common_description">
      Analysis of {{ name }} ({{ ticker }}) stock performance compared to the
      {{
         indexName
            ? "broader\n        market (" +
              indexName +
              ")"
            : "market"
      }}
      across multiple timeframes.
   </p>

   <div class="market_comparision_row">
      <div class="market_comparision_col">
         <h6>YTD Performance</h6>
         <ul>
            <li class="performance_green">
               <span class="cname" title="{{ name }} ({{ ticker }})">
                  {{
                     (name + " (" + ticker + ")").length > 20
                        ? (name | slice : 0 : 15) +
                          "... (" +
                          (ticker | slice : 0 : 3) +
                          "...)"
                        : name + " (" + ticker + ")"
                  }}
               </span>
               <span
                  [ngClass]="{
                     value__down: isValueNegative('pc_ytd'),
                     value__up: isValuePositive('pc_ytd')
                  }"
                  class="market_value"
               >
                  {{ getValueByLabel("pc_ytd") }}%
                  <img
                     *ngIf="isValuePositive('pc_ytd')"
                     src="../../../assets/icons/icon-market-up.svg"
                  />
                  <img
                     *ngIf="isValueNegative('pc_ytd')"
                     src="../../../assets/icons/icon-market-down.svg"
                  />
               </span>
            </li>
            <li
               class="performance_grey"
               *ngIf="indexName && getValueByLabel2('pc_ytd') !== null"
            >
               <span class="cname">{{ indexName }}</span>
               <span
                  [ngClass]="{
                     value__down: isValueNegative('pc_ytd', true),
                     value__up: isValuePositive('pc_ytd', true)
                  }"
                  class="market_value"
               >
                  {{ getValueByLabel2("pc_ytd") }}%
                  <img
                     *ngIf="isValuePositive('pc_ytd', true)"
                     src="../../../assets/icons/icon-market-up.svg"
                  />
                  <img
                     *ngIf="isValueNegative('pc_ytd', true)"
                     src="../../../assets/icons/icon-market-down.svg"
                  />
               </span>
            </li>
            <li
               class="performance_grey"
               *ngIf="!indexName || getValueByLabel2('pc_ytd') === null"
            >
               <span class="cname">Index</span>
               N/A
            </li>
         </ul>
         <h5 *ngIf="indexName && getValueByLabel2('pc_ytd') !== null">
            <span title="{{ name }}">{{
               name.length > 20 ? (name | slice : 0 : 15) + "..." : name
            }}</span>
            {{
               calculateDifference("pc_ytd").higherValue > 0
                  ? "Outperformed"
                  : "Underperformed"
            }}
            {{ indexName }} by
            <span>{{ calculateDifference("pc_ytd").difference }}%</span>
         </h5>
         <h5 *ngIf="!indexName || getValueByLabel2('pc_ytd') === null">
            Index comparison data not available
         </h5>
      </div>

      <div class="market_comparision_col">
         <h6>1Y Performance</h6>
         <ul>
            <li class="performance_green">
               <span class="cname" title="{{ name }} ({{ ticker }})">
                  {{
                     (name + " (" + ticker + ")").length > 20
                        ? (name | slice : 0 : 15) +
                          "... (" +
                          (ticker | slice : 0 : 3) +
                          "...)"
                        : name + " (" + ticker + ")"
                  }}
               </span>
               <span
                  [ngClass]="{
                     value__down: isValueNegative('pc_1y'),
                     value__up: isValuePositive('pc_1y')
                  }"
                  class="market_value"
               >
                  {{ getValueByLabel("pc_1y") }}%
                  <img
                     *ngIf="isValuePositive('pc_1y')"
                     src="../../../assets/icons/icon-market-up.svg"
                  />
                  <img
                     *ngIf="isValueNegative('pc_1y')"
                     src="../../../assets/icons/icon-market-down.svg"
                  />
               </span>
            </li>
            <li
               class="performance_grey"
               *ngIf="indexName && getValueByLabel2('pc_1y') !== null"
            >
               <span class="cname">{{ indexName }}</span>
               <span
                  [ngClass]="{
                     value__down: isValueNegative('pc_1y', true),
                     value__up: isValuePositive('pc_1y', true)
                  }"
                  class="market_value"
               >
                  {{ getValueByLabel2("pc_1y") }}%
                  <img
                     *ngIf="isValuePositive('pc_1y', true)"
                     src="../../../assets/icons/icon-market-up.svg"
                  />
                  <img
                     *ngIf="isValueNegative('pc_1y', true)"
                     src="../../../assets/icons/icon-market-down.svg"
                  />
               </span>
            </li>
            <li
               class="performance_grey"
               *ngIf="!indexName || getValueByLabel2('pc_1y') === null"
            >
               <span class="cname">Index</span>
               N/A
            </li>
         </ul>
         <h5 *ngIf="indexName && getValueByLabel2('pc_1y') !== null">
            <span title="{{ name }}">{{
               name.length > 20 ? (name | slice : 0 : 15) + "..." : name
            }}</span>
            {{
               calculateDifference("pc_1y").higherValue > 0
                  ? "Outperformed"
                  : "Underperformed"
            }}
            {{ indexName }} by
            <span>{{ calculateDifference("pc_1y").difference }}%</span>
         </h5>
         <h5 *ngIf="!indexName || getValueByLabel2('pc_1y') === null">
            Index comparison data not available
         </h5>
      </div>

      <div class="market_comparision_col">
         <h6>3Y Performance</h6>
         <ul>
            <li class="performance_green">
               <span class="cname" title="{{ name }} ({{ ticker }})">
                  {{
                     (name + " (" + ticker + ")").length > 20
                        ? (name | slice : 0 : 15) +
                          "... (" +
                          (ticker | slice : 0 : 3) +
                          "...)"
                        : name + " (" + ticker + ")"
                  }}
               </span>
               <span
                  [ngClass]="{
                     value__down: isValueNegative('pc_3y'),
                     value__up: isValuePositive('pc_3y')
                  }"
                  class="market_value"
               >
                  {{ getValueByLabel("pc_3y") }}%
                  <img
                     *ngIf="isValuePositive('pc_3y')"
                     src="../../../assets/icons/icon-market-up.svg"
                  />
                  <img
                     *ngIf="isValueNegative('pc_3y')"
                     src="../../../assets/icons/icon-market-down.svg"
                  />
               </span>
            </li>
            <li
               class="performance_grey"
               *ngIf="indexName && getValueByLabel2('pc_3y') !== null"
            >
               <span class="cname">{{ indexName }}</span>
               <span
                  [ngClass]="{
                     value__down: isValueNegative('pc_3y', true),
                     value__up: isValuePositive('pc_3y', true)
                  }"
                  class="market_value"
               >
                  {{ getValueByLabel2("pc_3y") }}%
                  <img
                     *ngIf="isValuePositive('pc_3y', true)"
                     src="../../../assets/icons/icon-market-up.svg"
                  />
                  <img
                     *ngIf="isValueNegative('pc_3y', true)"
                     src="../../../assets/icons/icon-market-down.svg"
                  />
               </span>
            </li>
            <li
               class="performance_grey"
               *ngIf="!indexName || getValueByLabel2('pc_3y') === null"
            >
               <span class="cname">Index</span>
               N/A
            </li>
         </ul>
         <h5 *ngIf="indexName && getValueByLabel2('pc_3y') !== null">
            <span title="{{ name }}">{{
               name.length > 20 ? (name | slice : 0 : 15) + "..." : name
            }}</span>
            {{
               calculateDifference("pc_3y").higherValue > 0
                  ? "Outperformed"
                  : "Underperformed"
            }}
            {{ indexName }} by
            <span>{{ calculateDifference("pc_3y").difference }}%</span>
         </h5>
         <h5 *ngIf="!indexName || getValueByLabel2('pc_3y') === null">
            Index comparison data not available
         </h5>
      </div>

      <div class="market_comparision_col">
         <h6>5Y Performance</h6>
         <ul>
            <li class="performance_green">
               <span class="cname" title="{{ name }} ({{ ticker }})">
                  {{
                     (name + " (" + ticker + ")").length > 20
                        ? (name | slice : 0 : 15) +
                          "... (" +
                          (ticker | slice : 0 : 3) +
                          "...)"
                        : name + " (" + ticker + ")"
                  }}
               </span>
               <span
                  [ngClass]="{
                     value__down: isValueNegative('pc_5y'),
                     value__up: isValuePositive('pc_5y')
                  }"
                  class="market_value"
               >
                  {{ getValueByLabel("pc_5y") }}%
                  <img
                     *ngIf="isValuePositive('pc_5y')"
                     src="../../../assets/icons/icon-market-up.svg"
                  />
                  <img
                     *ngIf="isValueNegative('pc_5y')"
                     src="../../../assets/icons/icon-market-down.svg"
                  />
               </span>
            </li>
            <li
               class="performance_grey"
               *ngIf="indexName && getValueByLabel2('pc_5y') !== null"
            >
               <span class="cname">{{ indexName }}</span>
               <span
                  [ngClass]="{
                     value__down: isValueNegative('pc_5y', true),
                     value__up: isValuePositive('pc_5y', true)
                  }"
                  class="market_value"
               >
                  {{ getValueByLabel2("pc_5y") }}%
                  <img
                     *ngIf="isValuePositive('pc_5y', true)"
                     src="../../../assets/icons/icon-market-up.svg"
                  />
                  <img
                     *ngIf="isValueNegative('pc_5y', true)"
                     src="../../../assets/icons/icon-market-down.svg"
                  />
               </span>
            </li>
            <li
               class="performance_grey"
               *ngIf="!indexName || getValueByLabel2('pc_5y') === null"
            >
               <span class="cname">Index</span>
               N/A
            </li>
         </ul>
         <h5 *ngIf="indexName && getValueByLabel2('pc_5y') !== null">
            <span title="{{ name }}">{{
               name.length > 20 ? (name | slice : 0 : 15) + "..." : name
            }}</span>
            {{
               calculateDifference("pc_5y").higherValue > 0
                  ? "Outperformed"
                  : "Underperformed"
            }}
            {{ indexName }} by
            <span>{{ calculateDifference("pc_5y").difference }}%</span>
         </h5>
         <h5 *ngIf="!indexName || getValueByLabel2('pc_5y') === null">
            Index comparison data not available
         </h5>
      </div>
   </div>
</div>
